import { Policy } from '@commandDrivenStateEngine/core/policies';
import { ClientLibraryType } from '@bett3r-dev/teselly-client-library';
import { OnboardingState } from '../state';
import { OnboardingCommand } from '../commands';

/**
 * Onboarding Init Policy
 *
 * Responsibilities:
 * - Subscribe to AccountsReadmodel on init (same source the account domain reads).
 * - Sync the current account's `onboardingCompletedAt` + `accountId` into
 *   onboarding state via `onboarding/data/set` (source: api).
 * - Cleanup subscription on unmount.
 *
 * First-entry detection (`selectIsOnboardingRequired`) reads the synced
 * `onboardingCompletedAt` flag — see TV1-1903 D1.
 */
export const createOnboardingInitPolicy = (
  backend: ClientLibraryType
): Policy<OnboardingState, OnboardingCommand> => ({
  name: 'onboarding-init',

  init: ({ dispatch }) => {
    const setFromAccount = ( account: any ) => {
      if ( !account ) return;
      dispatch(
        {
          type: 'onboarding/data/set',
          payload: {
            onboardingCompletedAt: account.onboardingCompletedAt ?? null,
            accountId: account.id ?? null
          }
        },
        { source: 'api' }
      );
    };

    const close = backend.subscriptions.AccountsReadmodel({}, ( change: any ) => {
      // Snapshot: full state initialization from the subscription.
      if ( change?.type === 'snapshot' ) {
        setFromAccount( change.data?.items?.[0]);
        return;
      }

      // Live changes: the account's onboarding flag may flip after completion.
      if ( change?.data ) {
        setFromAccount( change.data );
      }
    });

    return () => {
      if ( close?.close ) {
        close.close();
      }
    };
  }
});
